import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bonusUsage } from "./cl_BonusUsage";
import icons from "../../assets/images/sprite-other-icons.svg";
import PaginationComponent from "../common/PaginationComponent";
import BackArrow from "../common/BackArrow";
const BonusProgressBar = ({ stakeWagered, stakeToBeWagered }) => {
  const totalTarget = stakeWagered + stakeToBeWagered;
  const progressPercentage = totalTarget > 0 
    ? Math.floor((stakeWagered / totalTarget) * 100)
    : 0;

  return (
    <div className="SB-progressBar-container">
      <div className="SB-progressBar">
        <div
          className="SB-currentProgress"
          style={{ width: `${progressPercentage}%` }}
        ></div>
        <span className="SB-currentProgressValue">
          {progressPercentage}%
        </span>
      </div>
      <div className="SB-progressBar-minmax">
        <span className="SB-progressBar-min">
          {stakeWagered} KES / {totalTarget} KES
        </span>
      </div>

      <div className="SB-progressBar-legend">
        <div className="SB-progressBar-legendItem SB-used">
          <span className="SB-legendIndicator"></span>
          <span className="SB-legendlabel">Total Rolled</span>
        </div>
        <div className="SB-progressBar-legendItem SB-available">
          <span className="SB-legendIndicator"></span>
          <span className="SB-legendlabel">Rollover Target</span>
        </div>
      </div>
    </div>
  );
};

const RolloverInfo = ({ stakeWagered, stakeToBeWagered, totalBonus }) => {
  const totalTarget = stakeWagered + stakeToBeWagered;
  
  return (
    <div
      className="SB-rollover-info"
      style={{
        display: "flex",
        justifyContent: "space-around",
      }}
    >
      <div className="SB-rollover-item">
        <span className="SB-label">Total Rolled: </span>
        <span className="SB-value">{stakeWagered || 0} KES</span>
      </div>
      <div className="SB-rollover-item">
        <span className="SB-label">Rollover Target: </span>
        <span className="SB-value">{totalTarget || 0} KES</span>
      </div>
      <div className="SB-rollover-item">
        <span className="SB-label">Bonus: </span>
        <span className="SB-value">{totalBonus || 0} KES</span>
      </div>
    </div>
  );
};

const BonusDetailTerms = ({ data }) => (
  <div className="SB-bonusInfo-section">
    <div className="SB-bonusInfo-section__title">
      Bonus Usage Criteria
    </div>
    <div className="SB-bonusTerms-info">
      <ul>
        <li>
          <div className="SB-label">Max Winning %:</div>
          <div className="SB-value">{data?.maxWinPercentage}%</div>
        </li>
        <li>
          <div className="SB-label">Max Winning Amount:</div>
          <div className="SB-value">{data?.maxWinAmount}</div>
        </li>
        <li>
          <div className="SB-label">Remaining Rollover Amount:</div>
          <div className="SB-value">{data?.stakeToBeWagered}</div>
        </li>
        <li>
          <div className="SB-label">Max Bonus Amount:</div>
          <div className="SB-value">{data?.totalBonus}</div>
        </li>
        <li>
          <div className="SB-label">Min Stake:</div>
          <div className="SB-value">{data?.minStake}</div>
        </li>
        <li>
          <div className="SB-label">Roll over Criteria:</div>
          <div className="SB-value">
            {data?.rollOverMultiplier === 0
              ? "0"
              : `${data?.rollOverMultiplier} x Deposit`}
          </div>
        </li>
      </ul>
    </div>
  </div>
);

const BonusDetailsContent = ({ data }) => (
  <div className="SB-bonus-moreDetails">
    <div className="SB-bonusIDType-info">
      <div className="SB-bonusInfo-item SB-bonusInfo-bonusID">
        <div className="SB-lable">Bonus ID:</div>
        <div className="SB-value">{data?.userBonusId}</div>
      </div>
      <div className="SB-bonusInfo-item SB-bonusInfo-bonusType">
        <div className="SB-lable">Bonus Type:</div>
        <div className="SB-value">{data?.bonusType}</div>
      </div>
    </div>
    <div className="SB-bonusProgress-info">
      <BonusProgressBar 
        stakeWagered={data?.stakeWagered || 0} 
        stakeToBeWagered={data?.stakeToBeWagered || 0} 
      />
      <RolloverInfo 
        stakeWagered={data?.stakeWagered || 0}
        stakeToBeWagered={data?.stakeToBeWagered || 0}
        totalBonus={data?.totalBonus || 0}
      />
    </div>
    <BonusDetailTerms data={data} />
  </div>
);

const LoaderComponent = () => (
  <div className="SB-section-loader">
    <div className="SB-section-loader-container">
      <span className="SB-dot"></span>
      <span className="SB-dot"></span>
      <span className="SB-dot"></span>
      <span className="SB-dot"></span>
    </div>
  </div>
);

const NoDataMessage = () => (
  <div className="SB-msgBox">
    <div className="SB-msgBox-container">
      Currently there is no data available
    </div>
  </div>
);

const BonusUsage = (props) => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state?.signIn);
  const { bonusUsageData, loader } = useSelector((state) => state?.bonusUsage);
  
  const PAGE_SIZE = 10;
  const [detailedBonusIndices, setDetailedBonusIndices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const hasData = !loader && bonusUsageData?.data?.length > 0;
  const noData = !loader && (!bonusUsageData?.data?.length || bonusUsageData?.data?.length === 0);
  
  const filteredData = useMemo(() => {
    if (!bonusUsageData?.data) return [];
    return bonusUsageData.data.filter(item => {
      return !item.bonusType.toLowerCase().includes('free') && 
             !item.bonusType.toLowerCase().includes('freebet');
    });
  }, [bonusUsageData?.data]);

  const toggleBonusDetails = (index) => {
    setDetailedBonusIndices(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index) 
        : [...prev, index]
    );
  };

  const formatDate = (isoDateString) => {
    if (!isoDateString) return "";
    
    const date = new Date(isoDateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    setDetailedBonusIndices([]);
  }, [props]);

  useEffect(() => {
    setDetailedBonusIndices([]);
    
    if (userDetails?.userId) {
      dispatch(bonusUsage(userDetails?.userId, currentPage - 1));
    }
  }, [userDetails?.userId, currentPage, dispatch]);

  return (
    <>
      <div className="SB-bonusUsage-table">
        <div className="SB-table">
          <table>
            {hasData && filteredData.length > 0 && (
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Bonus Name</th>
                  <th>Amount</th>
                  <th>Bonus Applicable</th>
                  <th>Date of Expiry</th>
                  <th className="SB-bonus-status">Status</th>
                  <th className="SB-th-more">More</th>
                </tr>
              </thead>
            )}
            
            {hasData && filteredData.length > 0 && filteredData.map((data, ind) => (
              <tbody key={ind}>
                <tr>
                  <td>{formatDate(data?.addedDate)}</td>
                  <td>{data?.bonusType}</td>
                  <td>KES {data?.totalBonus}</td>
                  <td>{data?.applicableType}</td>
                  <td>{formatDate(data?.bonusExpiry)}</td>
                  <td className="SB-bonus-status">
                    <span className="SB-status SB-active">{data?.status}</span>
                  </td>
                  <td onClick={() => toggleBonusDetails(ind)}>
                    <div className="SB-iconSVG SB-accordionArrow SB-expanded" title="Arrow Right">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-angle-arrow-${detailedBonusIndices.includes(ind) ? 'down' : 'up'}`} />
                      </svg>
                    </div>
                  </td>
                </tr>
                
                {detailedBonusIndices.includes(ind) && (
                  <tr>
                    <td colSpan="7" className="SB-td-bonus-moreDetails">
                      <BonusDetailsContent data={data} />
                    </td>
                  </tr>
                )}
              </tbody>
            ))}
          </table>
          
          {loader && <LoaderComponent />}
          {(!hasData || filteredData.length === 0) && <NoDataMessage />}
        </div>
      </div>

      <div className="SB-bonusList">
        {loader && <LoaderComponent />}
        {hasData && filteredData.length > 0 && filteredData.map((data, ind) => (
          <div className="SB-bonus-item" key={ind}>
            <div className="SB-bonus-item-content">
              <div className="SB-bonus__col SB-col1">
                <div className="SB-bonus-dateID">
                  <div className="SB-bonusID">DATE</div>
                  <div className="SB-bonusDate">{formatDate(data?.addedDate)}</div>
                </div>
              </div>
              
              <div className="SB-bonus__col SB-col2">
                <div className="SB-bonusTypeApplicable">
                  <div className="SB-bonusType">{data?.bonusType}</div>
                  <div className="SB-bonusApplicableTo">
                    Applicable to: {data?.applicableType}
                  </div>
                </div>
                
                <div className="SB-bonus-statusAmount">
                  <div className="SB-bonusAmount">KES {data?.totalBonus}</div>
                  <div className="SB-statusAccordionArrow">
                    <span className="SB-status SB-active">{data?.status}</span>
                    <div
                      className="SB-iconSVG SB-accordionArrow"
                      title="Arrow Right"
                      onClick={() => toggleBonusDetails(ind)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-angle-arrow-${detailedBonusIndices.includes(ind) ? 'up' : 'down'}`} />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="SB-bonus__col SB-col3">
                <div className="SB-bonusExpiry">
                  <span>Expiry:</span>{" "}
                  <span>{formatDate(data?.bonusExpiry)}</span>
                </div>
              </div>
            </div>
            
            {detailedBonusIndices.includes(ind) && <BonusDetailsContent data={data} />}
          </div>
        ))}
        {(!hasData || filteredData.length === 0) && <NoDataMessage />}
      </div>
      {!loader && filteredData.length > 0 && (
        <PaginationComponent
          currentPage={currentPage}
          totalCount={filteredData.length}
          pageSize={PAGE_SIZE}
          onPageChange={(page) => setCurrentPage(page)}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default BonusUsage;